import { Component, inject } from '@angular/core';
import { Location } from '@angular/common';
@Component({
  selector: 'app-manual',
  templateUrl: './manual.component.html',
  styleUrls: ['./manual.component.css'],
  standalone: false,
})
export class ManualComponent {
  private location = inject(Location);


  back() {
    this.location.back();
  }
}
